import { GENERAL_ROUTES } from "@src/routes/routes";

// `contactSupport` is invoked from event handlers, Redux thunks, and other
// non-component code paths, so it must not depend on React hooks. Calling
// `useNavigate()` here throws "Invalid hook call" the moment a user clicks a
// support link (see Sentry WEB-UI-9AS / WEB-UI-9AY). Use imperative browser
// navigation so the callable contract stays hook-free while still landing the
// user on the in-app Get Help route.
export const contactSupport = () => {
  window.location.assign(GENERAL_ROUTES.GetHelp);
};

export const contactSales = () => {
  window.open("mailto:sales@intelligems.io?subject=Intelligems Sales Request");
};
